/**
 * Build Your Own Halloween Haul picker — forked from assets/bundle-shade-picker.js.
 * Loaded ONLY by the new build-your-own product template — the shared bundle-shade-picker.js
 * that three live products (Bundle & Save Gel Pack, PICK 1 SHADE Gel Kit, PICK 2 SHADES Gel Kit)
 * depend on is untouched by this file and by this build.
 *
 * Requires everything the original [data-bundle-picker] markup requires, PLUS these additional
 * elements nested inside the same [data-bundle-picker] root:
 *   .byo-opt-grid[data-byo-cards="shape"]   shape tiles, data-val: none | almond | oval | coffin | square
 *   [data-byo-shape-packs]                   empty container - one row per SELECTED shape, built by JS
 *   <select data-byo-lamp>                   values: none | salonpro
 *   <input type=checkbox data-byo-addon="base">
 *   <input type=checkbox data-byo-addon="wipes">
 *   <input type=checkbox data-byo-addon="flash">
 * Variant ids below were pulled live from the Admin API this session (not guessed) — see
 * research/2026-09-24_opallac-build-your-own-halloween-haul/ for the shade/lamp/add-on catalog.
 *
 * 2026-10-14 additions, all optional (every lookup null-checks its element):
 *   [data-byo-opt-soldout]      inside each shape .byo-opt-card - struck "Sold Out" badge,
 *                                shown when ALL lengths for that shape are unavailable
 *   [data-regular-price]        inside the submit button (theme.js's own hook) - this file
 *                                now overwrites it with the FULL kit total, since theme.js
 *                                only ever knows the base tier price
 *
 * 2026-10-14 v2: shape selection is MULTI-SELECT, not radio - a customer can pick Oval AND
 * Coffin in the same order. Each selected shape (selectedPacks[]) gets its own dynamically
 * built row ([data-byo-pack-row], inside [data-byo-shape-packs]) carrying its own length
 * <select> and its own quantity stepper - see renderPackRows()/wireNewPackRows().
 */
(function initBuildYourOwnPicker() {
  function run() {
    var bundleRoot = document.querySelector('[data-bundle-picker]');
    if (!bundleRoot) return;

    var REMOVE_ICON_HTML =
      '<span class="remove-color" style="display: none;">' +
      '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect y="0.5" width="24" height="24" rx="12" fill="black"></rect>' +
      '<path d="M9 9.5L15 15.5" stroke="white" stroke-width="1.2" stroke-linecap="round"></path>' +
      '<path d="M15 9.5L9 15.5" stroke="white" stroke-width="1.2" stroke-linecap="round"></path>' +
      '</svg></span>';

    var buttonContainer = bundleRoot.querySelector('.product-form__bundle-variants-buttons');
    var propertiesContainer = bundleRoot.querySelector('[data-bundle-properties]');
    var popup = bundleRoot.querySelector('#color-popup');
    var selectedCountEl = bundleRoot.querySelector('#selected-count');
    var totalCountEl = bundleRoot.querySelector('#total-count');
    var productForm = bundleRoot.closest('[data-product-form]');
    var submitBtn = productForm && productForm.querySelector('[data-add-to-cart]');
    var submitTextEl = submitBtn && submitBtn.querySelector('[data-add-to-cart-text]');
    // Captured ONCE, before this file (or theme.js's own _enableAddToCart(), which
    // replaces [data-add-to-cart-text]'s ENTIRE innerHTML on a variant-change event
    // and would otherwise destroy the nested [data-regular-price] span this relies
    // on) ever rewrites the button - "Add to cart" with no trailing price, read from
    // whatever the button's own label text already says server-side, so this never
    // hardcodes English or depends on a span surviving untouched.
    var addToCartBaseLabel = submitTextEl
      ? submitTextEl.textContent.replace(/\|.*$/, '').trim()
      : 'Add to cart';
    var productSection = bundleRoot.closest('[data-section-type="product"]');
    var sectionId = productSection && productSection.getAttribute('data-section-id');
    var productJsonEl = sectionId
      ? document.getElementById('ProductJson-' + sectionId)
      : document.querySelector('[id^="ProductJson-"]');

    // ---- Build Your Own extras: DOM refs ----
    var shapePacksWrap = bundleRoot.querySelector('[data-byo-shape-packs]');
    var lampSelect = bundleRoot.querySelector('[data-byo-lamp]');
    var addonCheckboxes = bundleRoot.querySelectorAll('[data-byo-addon]');

    // ---- Build Your Own extras: real variant ids (Admin API, 2026-10-13) ----
    var SHAPE_VARIANTS = {
      almond: { short: '52993288798487', medium: '52993288831255', long: '52993288864023' },
      oval: { short: '53036030165271', medium: '53036030198039', long: '53036030230807' },
      coffin: { short: '53036125225239', medium: '53036125258007', long: '53036125290775' },
      square: { short: '53036126109975', medium: '53036126142743', long: '53036126175511' }
    };
    var LAMP_VARIANT_ID = '52440776343831'; // Cordless ProSeries 48W UV LED Lamp, "1 Lamp"
    var ADDON_VARIANT_IDS = {
      base: '51411251593495', // 5-in-1 Rubber Base Gel
      wipes: '51542152020247', // Alcohol Pads, 20pk
      flash: '51731966460183', // Flash Cure LED Lamp
      brushset: '46567420526871' // Pro Nail Art Brush Set, 16pcs
    };

    var activeSlotIndex = null;
    var slots = [];
    var currentVariant = null;

    // ---- Build Your Own extras: state (separate from shade slots) ----
    // 2026-10-14 v2: an ARRAY, not a single value - a customer can have several different
    // shapes in the one order (e.g. Oval AND Coffin), each with its own length and quantity.
    var selectedPacks = []; // [{ shape: 'oval', length: 'medium', qty: 1 }, ...]
    var selectedLamp = 'none';
    var selectedAddons = [];

    function findPack(shapeKey) {
      for (var i = 0; i < selectedPacks.length; i++) {
        if (selectedPacks[i].shape === shapeKey) return selectedPacks[i];
      }
      return null;
    }

    function addPack(shapeKey) {
      if (findPack(shapeKey)) return;
      selectedPacks.push({ shape: shapeKey, length: firstAvailableLength(shapeKey), qty: 1 });
    }

    function removePack(shapeKey) {
      for (var i = 0; i < selectedPacks.length; i++) {
        if (selectedPacks[i].shape === shapeKey) {
          selectedPacks.splice(i, 1);
          return;
        }
      }
    }

    // ---- Build Your Own extras: live sold-out detection ----
    // 2026-10-14, Lionel: the 4 shapes are 4 SEPARATE products (not variants of this
    // one), so their stock can't be read from productJsonEl/getProductData() the way
    // getVariantFromSelectedOptions() reads THIS product's own variants - it has to be
    // fetched from each shape product's own storefront JSON. Fetched once at init,
    // read-only, same-origin, no admin credentials involved.
    var SHAPE_PRODUCT_HANDLES = {
      almond: 'gel-xtnd-almond-br-soft-gel-tips-s-m-l',
      oval: 'gel-xtnd-almond-br-soft-gel-tips-s-m-l-copy',
      coffin: 'gel-xtnd-coffin-br-soft-gel-tips-s-m-l',
      square: 'gel-xtnd-square-br-soft-gel-tips-s-m-l'
    };
    var shapeAvailability = {}; // variant id (string) -> boolean, filled async

    function loadShapeAvailability() {
      Object.keys(SHAPE_PRODUCT_HANDLES).forEach(function (key) {
        fetch('/products/' + SHAPE_PRODUCT_HANDLES[key] + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) {
            if (!product || !product.variants) return;
            product.variants.forEach(function (v) {
              shapeAvailability[String(v.id)] = !!v.available;
            });
            renderShapeAvailability();
          })
          .catch(function () { /* sold-out marking is a nicety - never block shopping on it failing */ });
      });
    }

    // Fails OPEN (treated as available) for anything not yet loaded or not recognised -
    // this is a UI hint, not the actual gate; Shopify's own inventory_policy: deny on
    // these variants is what actually stops an oversell at /cart/add.js regardless.
    function isShapeAnyAvailable(shapeKey) {
      var lengths = SHAPE_VARIANTS[shapeKey];
      if (!lengths) return true;
      var anyLoaded = false;
      for (var len in lengths) {
        var id = String(lengths[len]);
        if (shapeAvailability.hasOwnProperty(id)) {
          anyLoaded = true;
          if (shapeAvailability[id]) return true;
        }
      }
      return !anyLoaded;
    }

    function isLengthAvailable(shapeKey, lengthKey) {
      var lengths = SHAPE_VARIANTS[shapeKey];
      if (!lengths || !lengths[lengthKey]) return true;
      var id = String(lengths[lengthKey]);
      if (!shapeAvailability.hasOwnProperty(id)) return true;
      return shapeAvailability[id];
    }

    // First available length for a shape, used to auto-switch off a sold-out selection
    // the moment the customer picks a shape whose current length isn't in stock.
    function firstAvailableLength(shapeKey) {
      var order = ['short', 'medium', 'long'];
      for (var i = 0; i < order.length; i++) {
        if (isLengthAvailable(shapeKey, order[i])) return order[i];
      }
      return order[0];
    }

    function renderShapeAvailability() {
      var shapeContainer = bundleRoot.querySelector('[data-byo-cards="shape"]');
      if (shapeContainer) {
        shapeContainer.querySelectorAll('.byo-opt-card[data-val]').forEach(function (card) {
          var val = card.getAttribute('data-val');
          if (val === 'none') return;
          card.classList.toggle('is-soldout', !isShapeAnyAvailable(val));
        });
      }

      // A length picked earlier can turn out to be sold out only once this async fetch
      // resolves - auto-switch any affected pack's length rather than leaving a struck-
      // through option selected.
      selectedPacks.forEach(function (pack) {
        if (!isLengthAvailable(pack.shape, pack.length)) {
          pack.length = firstAvailableLength(pack.shape);
        }
      });

      renderPackRows();
    }

    // One row per SELECTED shape (multi-select, not radio) - name + length <select> +
    // quantity stepper + remove button, all built fresh from selectedPacks[] since the
    // row count is dynamic. Rebuilds the DOM wholesale, so this is called only on
    // add/remove-pack actions; a qty +/- click on an existing row patches that row's own
    // text/disabled-state directly instead, to avoid losing focus/scroll on every click.
    function renderPackRows() {
      if (!shapePacksWrap) return;
      shapePacksWrap.innerHTML = '';

      selectedPacks.forEach(function (pack) {
        var sc = getShapeConfig(pack.shape);
        var label = sc ? sc.label : pack.shape;

        var lengthOptionsHtml = ['short', 'medium', 'long'].map(function (len) {
          var selAttr = (len === pack.length) ? ' selected' : '';
          var soldOut = !isLengthAvailable(pack.shape, len);
          var lenLabel = len.charAt(0).toUpperCase() + len.slice(1);
          return '<option value="' + len + '"' + selAttr + (soldOut ? ' disabled' : '') + '>' +
            lenLabel + (soldOut ? ' - Sold Out' : '') + '</option>';
        }).join('');

        var row = document.createElement('div');
        row.className = 'byo-pack-row';
        row.setAttribute('data-byo-pack-row', '');
        row.setAttribute('data-shape', pack.shape);
        row.innerHTML =
          '<span class="byo-pack-row__name">' + label + '</span>' +
          '<select class="byo-pack-row__length" data-byo-pack-length>' + lengthOptionsHtml + '</select>' +
          '<span class="byo-qty-ctrl byo-pack-row__qty">' +
            '<button type="button" class="byo-qty-btn" data-byo-pack-qty-minus aria-label="Decrease quantity"' +
              (pack.qty <= 1 ? ' disabled' : '') + '>&#8722;</button>' +
            '<span class="byo-qty-val" data-byo-pack-qty-val>' + pack.qty + '</span>' +
            '<button type="button" class="byo-qty-btn" data-byo-pack-qty-plus aria-label="Increase quantity">+</button>' +
          '</span>' +
          '<button type="button" class="byo-pack-row__remove" data-byo-pack-remove aria-label="Remove ' + label + '">&times;</button>';

        shapePacksWrap.appendChild(row);
      });

      wireNewPackRows();
    }

    function wireNewPackRows() {
      if (!shapePacksWrap) return;
      shapePacksWrap.querySelectorAll('[data-byo-pack-row]').forEach(function (row) {
        var shapeKey = row.getAttribute('data-shape');

        var lenSelect = row.querySelector('[data-byo-pack-length]');
        if (lenSelect) {
          lenSelect.addEventListener('change', function () {
            var pack = findPack(shapeKey);
            if (!pack) return;
            pack.length = lenSelect.value;
            syncLineItemProperties();
            updateSubmitState();
            recalcSavingsPanel();
          });
        }

        var minus = row.querySelector('[data-byo-pack-qty-minus]');
        var plus = row.querySelector('[data-byo-pack-qty-plus]');
        var valEl = row.querySelector('[data-byo-pack-qty-val]');

        if (minus) {
          minus.addEventListener('click', function () {
            var pack = findPack(shapeKey);
            if (!pack) return;
            if (pack.qty > 1) pack.qty -= 1;
            if (valEl) valEl.textContent = String(pack.qty);
            minus.disabled = pack.qty <= 1;
            syncLineItemProperties();
            updateSubmitState();
            recalcSavingsPanel();
          });
        }
        if (plus) {
          plus.addEventListener('click', function () {
            var pack = findPack(shapeKey);
            if (!pack) return;
            pack.qty += 1;
            if (valEl) valEl.textContent = String(pack.qty);
            if (minus) minus.disabled = false;
            syncLineItemProperties();
            updateSubmitState();
            recalcSavingsPanel();
          });
        }

        var remove = row.querySelector('[data-byo-pack-remove]');
        if (remove) {
          remove.addEventListener('click', function () {
            removePack(shapeKey);
            renderShapeSelection();
            syncLineItemProperties();
            updateSubmitState();
            recalcSavingsPanel();
          });
        }
      });
    }

    // Keeps the shape TILES (data-sel) in sync with selectedPacks[], then rebuilds the
    // per-shape rows below them. Called after any tile click or row-remove click.
    function renderShapeSelection() {
      var shapeContainer = bundleRoot.querySelector('[data-byo-cards="shape"]');
      if (shapeContainer) {
        shapeContainer.querySelectorAll('.byo-opt-card[data-val]').forEach(function (card) {
          var val = card.getAttribute('data-val');
          var sel = (val === 'none') ? (selectedPacks.length === 0) : !!findPack(val);
          card.setAttribute('data-sel', sel ? 'true' : 'false');
        });
      }
      renderPackRows();
    }

    // ---- Build Your Own extras: pricing config + savings panel (matches the approved mockup) ----
    var configEl = sectionId
      ? document.getElementById('BuildYourOwnConfig-' + sectionId)
      : document.querySelector('[id^="BuildYourOwnConfig-"]');
    var BYO_CONFIG = null;
    try {
      BYO_CONFIG = configEl ? JSON.parse(configEl.textContent) : null;
    } catch (e) {
      BYO_CONFIG = null;
    }

    function fmtMoney(n) {
      return '$' + Number(n).toFixed(2);
    }

    function getShapeConfig(key) {
      if (!BYO_CONFIG || !BYO_CONFIG.shapes) return null;
      for (var i = 0; i < BYO_CONFIG.shapes.length; i++) {
        if (BYO_CONFIG.shapes[i].key === key) return BYO_CONFIG.shapes[i];
      }
      return null;
    }

    function getAddonConfig(key) {
      if (!BYO_CONFIG || !BYO_CONFIG.addons) return null;
      for (var i = 0; i < BYO_CONFIG.addons.length; i++) {
        if (BYO_CONFIG.addons[i].key === key) return BYO_CONFIG.addons[i];
      }
      return null;
    }

    function pctOff(price, standalone) {
      if (!standalone || standalone <= 0) return null;
      return Math.round((1 - (price / standalone)) * 100);
    }

    function lineHtml(label, price, standalone) {
      var pct = pctOff(price, standalone);
      // The outer span keeps min-width+right-align for column alignment across rows; the
      // background-line strikethrough goes on the inner span instead, which has no forced
      // width and shrinks to the text - see product-template.liquid's .byo-qb-was__text.
      var was = standalone
        ? '<span class="byo-qb-was"><span class="byo-qb-was__text">' + fmtMoney(standalone) + '</span></span>'
        : '';
      var pctBadge = (pct !== null) ? ' <span class="byo-qb-pct">' + pct + '% off</span>' : '';
      return '<div class="byo-qb-line"><span>' + label + pctBadge + '</span><span class="byo-qb-amounts">' + was + '<span class="byo-qb-now">' + fmtMoney(price) + '</span></span></div>';
    }

    function recalcSavingsPanel() {
      var qbLines = bundleRoot.querySelector('[data-byo-qb-lines]');
      var qbTotal = bundleRoot.querySelector('[data-byo-qb-total]');
      var qbSave = bundleRoot.querySelector('[data-byo-qb-save]');
      if (!qbLines || !qbTotal || !BYO_CONFIG || !currentVariant) return;

      var tierPrice = parseFloat(currentVariant.price) / 100;
      var tierCompareAt = BYO_CONFIG.tier_compare_at ? BYO_CONFIG.tier_compare_at[String(slots.length)] : null;
      var lines = [lineHtml(slots.length + ' gel shades', tierPrice, tierCompareAt)];
      var total = tierPrice;
      var extrasSaving = 0;
      if (tierCompareAt) extrasSaving += (tierCompareAt - tierPrice);

      // 2026-10-14 v2: one line per SELECTED shape, not just one shape overall.
      selectedPacks.forEach(function (pack) {
        var sc = getShapeConfig(pack.shape);
        if (!sc) return;
        var qty = pack.qty || 1;
        var shapeLinePrice = sc.price_delta * qty;
        var shapeLineStandalone = sc.standalone ? sc.standalone * qty : sc.standalone;
        total += shapeLinePrice;
        if (sc.standalone) extrasSaving += (shapeLineStandalone - shapeLinePrice);
        var lenName = pack.length ? (pack.length.charAt(0).toUpperCase() + pack.length.slice(1)) : '';
        var qtyTag = qty > 1 ? ' x' + qty : '';
        lines.push(lineHtml('Gel-XTND ' + sc.label + (lenName ? ' (' + lenName + ')' : '') + qtyTag, shapeLinePrice, shapeLineStandalone));
      });
      if (selectedLamp !== 'none' && BYO_CONFIG.lamp && BYO_CONFIG.lamp[selectedLamp]) {
        var lc = BYO_CONFIG.lamp[selectedLamp];
        total += lc.price_delta;
        if (lc.standalone) extrasSaving += (lc.standalone - lc.price_delta);
        lines.push(lineHtml(lc.label, lc.price_delta, lc.standalone));
      }
      for (var a = 0; a < selectedAddons.length; a++) {
        var ac = getAddonConfig(selectedAddons[a]);
        if (ac) {
          total += ac.price_delta;
          if (ac.standalone) extrasSaving += (ac.standalone - ac.price_delta);
          lines.push(lineHtml(ac.label, ac.price_delta, ac.standalone));
        }
      }

      qbLines.innerHTML = lines.join('');
      qbTotal.textContent = fmtMoney(total);
      if (qbSave) {
        qbSave.innerHTML = extrasSaving > 0
          ? 'You are saving <b>' + fmtMoney(extrasSaving) + '</b> today, on the gel shades and everything else in your kit.'
          : 'Add a Gel-XTND extension, lamp, or finishing extras above and they will ride along at a discount too.';
      }

      // 2026-10-14, Lionel: the submit button's own price span (data-regular-price)
      // only ever reflected currentVariant.price - the base tier, with no knowledge of
      // shape/lamp/addon extras - so it kept showing e.g. $78.00 while this panel's
      // own Total read $255.25. First attempt just wrote into the EXISTING nested
      // span, deferred a tick to win any race - but theme.js's Product class
      // (_enableAddToCart(), fired on every variant-change event) replaces
      // [data-add-to-cart-text]'s ENTIRE innerHTML with a bare label string, which
      // DESTROYS that nested span outright, not just its text - after which the old
      // code's querySelector found nothing and silently gave up for the rest of the
      // session. This version REBUILDS the whole button text every time instead of
      // hoping the span survives, so it is correct however many times theme.js (or
      // anything else) has rewritten the button in between. Deferred one tick so this
      // write always lands LAST regardless of listener registration order.
      if (submitTextEl && isVariantSellable(currentVariant)) {
        setTimeout(function () {
          submitTextEl.innerHTML = addToCartBaseLabel +
            '  | <span class="btnprice" data-regular-price>' + fmtMoney(total) + '</span>';
        }, 0);
      }
    }

    // Photo-card picker for lamp (shape has its own multi-select wiring, wireShapeCards()
    // below). Sets the same hidden <select> this file already reads from, then dispatches
    // 'change' so every existing handler below keeps working unmodified.
    function wireOptCards(container, hiddenInput) {
      if (!container || !hiddenInput) return;
      container.querySelectorAll('.byo-opt-card').forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.classList.contains('is-soldout')) return;
          container.querySelectorAll('.byo-opt-card').forEach(function (c) {
            c.setAttribute('data-sel', 'false');
          });
          card.setAttribute('data-sel', 'true');
          hiddenInput.value = card.getAttribute('data-val');
          hiddenInput.dispatchEvent(new Event('change'));
        });
      });
    }

    function getProductData() {
      if (!productJsonEl) return null;
      try {
        return JSON.parse(productJsonEl.textContent);
      } catch (e) {
        return null;
      }
    }

    function getSizeSelector() {
      var index = bundleRoot.getAttribute('data-size-option-index');
      if (index !== null && index !== '') {
        return document.getElementById('SingleOptionSelector-' + index);
      }
      if (productForm) {
        return productForm.querySelector('.custom-product-form__controls-group .single-option-selector');
      }
      return null;
    }

    function parseCountFromValue(value) {
      var n = parseInt(value, 10);
      if (!isNaN(n) && n > 0) return n;
      var match = String(value).match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }

    function getSlotCountFromVariant(variant) {
      if (!variant) return 0;
      var i;
      for (i = 1; i <= 3; i++) {
        if (variant['option' + i]) {
          var count = parseCountFromValue(variant['option' + i]);
          if (count > 0) return count;
        }
      }
      return parseCountFromValue(variant.title);
    }

    function getSlotCount(variant) {
      var sizeSelect = getSizeSelector();
      if (sizeSelect && sizeSelect.value) {
        var fromSelect = parseCountFromValue(sizeSelect.value);
        if (fromSelect > 0) return fromSelect;
      }
      var fromVariant = getSlotCountFromVariant(variant);
      if (fromVariant > 0) return fromVariant;
      var initial = parseInt(bundleRoot.getAttribute('data-initial-slot-count'), 10);
      return !isNaN(initial) && initial > 0 ? initial : 0;
    }

    function findVariantById(id) {
      var product = getProductData();
      if (!product || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(id)) return product.variants[i];
      }
      return null;
    }

    function getVariantFromSelectedOptions() {
      var product = getProductData();
      if (!product || !product.variants || !productForm) return null;

      var selects = productForm.querySelectorAll('.single-option-selector');
      if (!selects.length) return null;

      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        var matches = true;

        for (var s = 0; s < selects.length; s++) {
          var optionKey = selects[s].getAttribute('data-index');
          if (!optionKey || variant[optionKey] !== selects[s].value) {
            matches = false;
            break;
          }
        }

        if (matches) return variant;
      }

      return null;
    }

    function syncMasterSelect(variant) {
      if (!variant || !productForm) return;
      var masterSelect = productForm.querySelector('[name="id"]');
      if (masterSelect && String(masterSelect.value) !== String(variant.id)) {
        masterSelect.value = variant.id;
      }
    }

    function getFilledCount() {
      var count = 0;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i] && slots[i].variantId) count++;
      }
      return count;
    }

    // 2026-10-15 (researcher): ONLY the shade slots belong here. Confirmed live against the
    // Function Studio "Expand cart lines" node (read from attributes, no component-items,
    // "discount the price of the whole bundle" OFF): the component list is purely an itemized
    // breakdown/weight-split of the PARENT LINE'S EXISTING PRICE — there is no field anywhere
    // in that node that adds charge for whatever is listed here, only one that can discount it.
    // The base tier price (e.g. $78 for a 5-pack) was only ever meant to cover the shades, same
    // as how the existing Bundle & Save / Pick 1 / Pick 2 groups work (their flat price already
    // covers everything listed). Shape/lamp/add-on extras are real add-on cost on TOP of that
    // tier price, so they must stay OUT of this array and ride as their own separately priced
    // cart lines instead (buildExtraLineItems(), called from buildAddToCartItems()) — putting
    // them here previously silently gave them away for free, since nothing ever actually billed
    // for them.
    function buildComponentsArray() {
      var components = [];

      for (var i = 0; i < slots.length; i++) {
        if (!slots[i] || !slots[i].variantId) continue;
        components.push({
          id: String(slots[i].variantId),
          qty: 1
        });
      }

      return components;
    }

    // Shape/lamp/add-on extras — real, separately priced cart lines. Shade slots are
    // deliberately left out of this list: the base tier variant's price already covers "any
    // N shades" (see buildComponentsArray() above for why these can't just ride inside the
    // Function Studio component breakdown instead).
    function buildExtraLineItems() {
      var items = [];
      selectedPacks.forEach(function (pack) {
        var variantMap = SHAPE_VARIANTS[pack.shape];
        var shapeVariantId = variantMap && variantMap[pack.length];
        if (shapeVariantId) items.push({ id: Number(shapeVariantId), quantity: pack.qty || 1 });
      });
      if (selectedLamp !== 'none') {
        items.push({ id: Number(LAMP_VARIANT_ID), quantity: 1 });
      }
      for (var a = 0; a < selectedAddons.length; a++) {
        var addonId = ADDON_VARIANT_IDS[selectedAddons[a]];
        if (addonId) items.push({ id: Number(addonId), quantity: 1 });
      }
      return items;
    }

    // Inherited unchanged from assets/bundle-shade-picker.js — this gate is specific to the
    // two PICK kits and is irrelevant to this product, but is left exactly as-is rather than
    // removed, so this fork stays a straightforward diff against the shared file.
    var KIT_HARDWARE_PRODUCTS = {
      '4553200009287': true,   // PICK 1 SHADE Gel Kit NEW
      '10229494546711': true   // PICK 2 SHADES Gel Kit NEW
    };
    var KIT_HARDWARE_COMPONENTS = [
      { id: '52440776343831', qty: 1 }, // Cordless ProSeries 48w Lamp (1 Lamp)
      { id: '29694617539',    qty: 1 }, // Gel Base Coat
      { id: '46090378772759', qty: 1 }, // NO WIPE Gel Top Coat
      { id: '15869784686663', qty: 1 }, // Opallac File
      { id: '15869756375111', qty: 1 }  // Opallac Nail Buffer
    ];

    function buildComponentsJson() {
      var components = buildComponentsArray();
      var product = getProductData();
      if (product && KIT_HARDWARE_PRODUCTS[String(product.id)]) {
        components = components.concat(KIT_HARDWARE_COMPONENTS);
      }
      return JSON.stringify(components);
    }

    // Relaxed from the shared file's flat "components.length === expected" count match:
    // extras make components.length exceed the shade count by design, so validity is now
    // "all shade slots filled" AND every selected pack has a length — lamp and add-ons never block.
    function isPayloadValid() {
      if (!isComplete()) return false;
      for (var i = 0; i < selectedPacks.length; i++) {
        var pack = selectedPacks[i];
        if (!pack.length) return false;
        // Belt-and-suspenders alongside the UI-level sold-out marking (renderShapeAvailability()) -
        // fails open (returns true) if availability hasn't loaded yet, same as isLengthAvailable()
        // itself; Shopify's own inventory_policy: deny on these variants is the real backstop.
        if (!isLengthAvailable(pack.shape, pack.length)) return false;
      }
      return true;
    }

    function isVariantSellable(variant) {
      if (!variant) return false;
      if (!variant.inventory_management) return true;
      return !!variant.available;
    }

    function isComplete() {
      return slots.length > 0 && getFilledCount() === slots.length;
    }

    function canAddToCart() {
      return isVariantSellable(currentVariant) && isPayloadValid();
    }

    function showFormError(message) {
      var errorWrapper = productForm && productForm.querySelector('[data-error-message-wrapper]');
      var errorMessage = productForm && productForm.querySelector('[data-error-message]');
      if (!errorMessage || !errorWrapper) return;
      errorMessage.textContent = message;
      errorWrapper.classList.remove('product-form__error-message-wrapper--hidden');
      errorWrapper.removeAttribute('aria-hidden');
    }

    function hideFormError() {
      var errorWrapper = productForm && productForm.querySelector('[data-error-message-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.add('product-form__error-message-wrapper--hidden');
      errorWrapper.setAttribute('aria-hidden', 'true');
    }

    function setLoadingState(isLoading) {
      if (!submitBtn) return;
      if (isLoading) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
      } else {
        updateSubmitState();
      }
    }

    // 2026-10-15 (researcher): Function Studio's cart-transform group for this product is live
    // (the "Build Your own Bundle" group/expand node, reading the shade-only _components below
    // and itemizing/weight-splitting the parent's own tier price across them — see
    // buildComponentsArray() for why only shades belong there). Shape/lamp/add-on extras ride
    // as their own real cart lines (buildExtraLineItems()) since nothing in Function Studio can
    // add charge for them — this is the permanent shape, not a workaround to remove later.
    function buildAddToCartItems() {
      syncMasterSelect(currentVariant);
      syncLineItemProperties();

      var items = [
        {
          id: Number(currentVariant.id),
          quantity: 1,
          properties: { _components: buildComponentsJson() }
        }
      ];

      return items.concat(buildExtraLineItems());
    }

    function postBundleAdd() {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: buildAddToCartItems() })
      }).then(function (response) {
        return response.json().then(function (json) {
          if (json.status && json.status !== 200) {
            var err = new Error(json.description || json.message || 'Could not add bundle to cart');
            err.isSoldOut = /sold out/i.test(err.message);
            throw err;
          }

          // Multi-item /cart/add.js resolves { items: [...] } on success, unlike the old
          // single-item shape (the line object directly) — the base kit line is items[0].
          var addedLines = json.items || [json];
          var savedComponents =
            addedLines[0] &&
            addedLines[0].properties &&
            (addedLines[0].properties._components || addedLines[0].properties['_components']);
          if (!savedComponents) {
            console.warn('Build Your Own added but _components property was not returned on the line item', json);
          }

          return json;
        });
      });
    }

    function wait(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function refreshCartCount() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var countEls = document.querySelectorAll('.cart-Update');
          for (var i = 0; i < countEls.length; i++) {
            countEls[i].textContent = String(cart.item_count);
          }
        })
        .catch(function () {});
    }

    function addBundleToCart() {
      if (!isPayloadValid()) {
        showFormError('Please choose all ' + slots.length + ' shades before adding to cart.');
        updateSubmitState();
        return Promise.resolve();
      }

      hideFormError();
      setLoadingState(true);

      return postBundleAdd()
        .catch(function (error) {
          if (!error.isSoldOut) throw error;
          return wait(600).then(postBundleAdd);
        })
        .then(function () {
          hideFormError();
          document.dispatchEvent(new Event('cart:updated'));
          // 2026-10-14, Lionel: button price was reported reverting to the base-tier
          // figure right after a successful add - root cause not pinned down with
          // certainty (no browser access to trace it live; the likeliest candidate,
          // theme.js's own native form-submit handler never being stopped from firing
          // alongside this one, is fixed above). This re-asserts the correct kit total
          // as cheap, independent insurance regardless of what the actual cause turns
          // out to be - nothing in this file resets selectedPacks/selectedLamp/
          // selectedAddons on a successful add, so recalculating here is always safe
          // and always reflects the real current selection.
          recalcSavingsPanel();
          return refreshCartCount();
        })
        .catch(function (error) {
          console.error('Build Your Own add to cart failed', {
            variantId: currentVariant && currentVariant.id,
            slotCount: slots.length,
            packs: selectedPacks,
            lamp: selectedLamp,
            addons: selectedAddons,
            components: buildComponentsArray(),
            message: error && error.message
          });
          var message = error && error.message ? error.message : 'Could not add to cart.';
          if (error && error.isSoldOut) {
            message += ' This usually means a selected shade, shape, or add-on is out of stock, or the cart needs to be cleared after a previous failed add.';
          }
          showFormError(message);
        })
        .then(function () {
          setLoadingState(false);
        });
    }

    function setSubmitEnabled(enabled) {
      if (!submitBtn) return;
      var on = !!enabled;
      submitBtn.disabled = !on;
      submitBtn.setAttribute('aria-disabled', on ? 'false' : 'true');
    }

    function updateSubmitState() {
      setSubmitEnabled(canAddToCart());
    }

    function scheduleSubmitStateUpdate() {
      setTimeout(updateSubmitState, 0);
      setTimeout(updateSubmitState, 50);
    }

    function updateCountDisplay() {
      if (selectedCountEl) selectedCountEl.textContent = String(getFilledCount());
      if (totalCountEl) totalCountEl.textContent = String(slots.length);
    }

    function syncLineItemProperties() {
      if (!propertiesContainer) return;
      propertiesContainer.innerHTML = '';

      function addProperty(name, value) {
        if (value === null || value === undefined || value === '') return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.value = String(value);
        propertiesContainer.appendChild(input);
      }

      if (isComplete()) {
        addProperty('_components', buildComponentsJson());
      }
    }

    function clearSlotButton(button) {
      button.setAttribute('data-selected', 'false');
      var label = button.querySelector('.color-label');
      var removeIcon = button.querySelector('.remove-color');
      var preview = button.querySelector('img.color-preview');
      if (preview) preview.remove();
      if (label) label.textContent = 'Add';
      if (removeIcon) removeIcon.style.display = 'none';
    }

    function fillSlotButton(button, slot) {
      button.setAttribute('data-selected', 'true');
      var label = button.querySelector('.color-label');
      var removeIcon = button.querySelector('.remove-color');
      var existingImg = button.querySelector('img.color-preview');
      if (existingImg) existingImg.remove();

      if (slot.imgSrc) {
        var previewImg = document.createElement('img');
        previewImg.src = slot.imgSrc;
        previewImg.alt = slot.title || '';
        previewImg.className = 'color-preview';
        if (label) button.insertBefore(previewImg, label);
        else button.appendChild(previewImg);
      }

      if (label) label.textContent = slot.title || 'Add';
      if (removeIcon) removeIcon.style.display = 'inline-block';
    }

    function createSlotButton(index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'add-color-btn';
      button.setAttribute('data-index', String(index));
      button.setAttribute('data-selected', 'false');
      button.innerHTML = '<span class="color-label">Add</span>' + REMOVE_ICON_HTML;
      return button;
    }

    function rebuildSlotButtons(count) {
      if (!count || count < 1) count = 1;
      slots = new Array(count);
      if (buttonContainer) {
        buttonContainer.innerHTML = '';
        for (var i = 0; i < count; i++) {
          buttonContainer.appendChild(createSlotButton(i));
        }
      }
      updateCountDisplay();
      syncLineItemProperties();
      updateSubmitState();
    }

    function resolveCurrentVariant() {
      var fromOptions = getVariantFromSelectedOptions();
      if (fromOptions) return fromOptions;

      var masterSelect = productForm && productForm.querySelector('[name="id"]');
      if (masterSelect && masterSelect.value) {
        var fromMaster = findVariantById(masterSelect.value);
        if (fromMaster) return fromMaster;
      }

      return currentVariant;
    }

    function applyVariant(variant) {
      if (!variant) variant = resolveCurrentVariant();
      currentVariant = variant || null;
      syncMasterSelect(variant);
      rebuildSlotButtons(getSlotCount(variant));
      scheduleSubmitStateUpdate();
      recalcSavingsPanel();
    }

    function openPopup() {
      if (popup) popup.style.display = 'block';
    }

    function closePopup() {
      if (popup) popup.style.display = 'none';
      activeSlotIndex = null;
    }

    // ---- Build Your Own extras: wiring ----
    // 2026-10-14 v2: shape tiles are now MULTI-SELECT (toggle, not radio) - clicking an
    // unselected shape adds it as a new pack (own length + qty row below); clicking an
    // already-selected one removes it; "No extension" clears every pack.
    function wireShapeCards(container) {
      if (!container) return;
      container.querySelectorAll('.byo-opt-card[data-val]').forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.classList.contains('is-soldout')) return;
          var val = card.getAttribute('data-val');
          if (val === 'none') {
            selectedPacks = [];
          } else if (findPack(val)) {
            removePack(val);
          } else {
            addPack(val);
          }
          renderShapeSelection();
          syncLineItemProperties();
          updateSubmitState();
          recalcSavingsPanel();
        });
      });
    }
    if (lampSelect) {
      lampSelect.addEventListener('change', function () {
        selectedLamp = lampSelect.value || 'none';
        syncLineItemProperties();
        updateSubmitState();
        recalcSavingsPanel();
      });
    }
    addonCheckboxes.forEach(function (box) {
      box.addEventListener('change', function () {
        var key = box.getAttribute('data-byo-addon');
        var idx = selectedAddons.indexOf(key);
        if (box.checked && idx === -1) selectedAddons.push(key);
        else if (!box.checked && idx !== -1) selectedAddons.splice(idx, 1);
        syncLineItemProperties();
        updateSubmitState();
        recalcSavingsPanel();
      });
    });

    // Photo-card picker UI (matches the approved mockup pixel-for-pixel). Shape is its
    // own multi-select wiring (wireShapeCards(), above); lamp stays single-select,
    // driving the hidden <select data-byo-lamp> via a synthetic 'change' event.
    wireShapeCards(bundleRoot.querySelector('[data-byo-cards="shape"]'));
    wireOptCards(bundleRoot.querySelector('[data-byo-cards="lamp"]'), lampSelect);

    loadShapeAvailability();
    renderShapeSelection();

    bundleRoot.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.add-color-btn');
      if (addBtn && buttonContainer && buttonContainer.contains(addBtn)) {
        if (e.target.closest('.remove-color')) return;
        e.preventDefault();
        activeSlotIndex = parseInt(addBtn.getAttribute('data-index'), 10);
        openPopup();
        return;
      }

      var removeBtn = e.target.closest('.remove-color');
      if (removeBtn && buttonContainer && buttonContainer.contains(removeBtn)) {
        e.preventDefault();
        e.stopPropagation();
        var slotButton = removeBtn.closest('.add-color-btn');
        if (!slotButton) return;
        var index = parseInt(slotButton.getAttribute('data-index'), 10);
        slots[index] = null;
        clearSlotButton(slotButton);
        updateCountDisplay();
        syncLineItemProperties();
        updateSubmitState();
        return;
      }

      var colorItem = e.target.closest('#color-list li');
      if (colorItem && popup && popup.contains(colorItem) && activeSlotIndex !== null) {
        if (colorItem.getAttribute('data-variant-available') === 'false') return;
        var variantId = colorItem.getAttribute('data-variant-id');
        if (!variantId) return;

        var img = colorItem.querySelector('img');
        slots[activeSlotIndex] = {
          variantId: variantId,
          title: colorItem.getAttribute('data-color') || '',
          imgSrc: img ? img.getAttribute('src') : ''
        };

        var targetButton = buttonContainer.querySelector(
          '.add-color-btn[data-index="' + activeSlotIndex + '"]'
        );
        if (targetButton) fillSlotButton(targetButton, slots[activeSlotIndex]);

        updateCountDisplay();
        syncLineItemProperties();
        updateSubmitState();
        closePopup();
        return;
      }

      if (e.target.closest('.popup-header .close')) {
        e.preventDefault();
        closePopup();
      }
    });

    if (popup) {
      popup.addEventListener('click', function (e) {
        if (e.target === popup) closePopup();
      });
    }

    if (productForm) {
      // 2026-10-14, Lionel: moved from productForm.addEventListener('submit', fn, true) to a
      // document-level capture listener. theme.js's own Product class ALSO binds a 'submit'
      // listener directly on this same productForm (_initAddToCart(), bubble phase, no capture
      // flag) - and for two listeners on the SAME element, the capture/bubble flag does NOT
      // decide order: they fire in REGISTRATION order during the "at target" phase. theme.js's
      // section-init runs on DOMContentLoaded and this file's script tag loads later in the
      // page, so theme's listener was very likely registered FIRST - meaning it could run
      // before this one regardless of the `true` (capture) flag that was here, and critically
      // it never calls stopPropagation() - so its own native, single-item (no _components, no
      // shape/lamp/addon lines) /cart/add.js call could fire ALONGSIDE this file's full
      // multi-item one on every single click. A listener on an ANCESTOR in the capture phase
      // always runs before ANY listener on the target itself, regardless of registration order -
      // so intercepting on `document` and calling stopPropagation() here, during capture,
      // stops the event before it ever reaches productForm's own listeners at all.
      document.addEventListener(
        'submit',
        function (e) {
          if (e.target !== productForm) return;

          currentVariant = resolveCurrentVariant();
          syncMasterSelect(currentVariant);
          syncLineItemProperties();

          e.preventDefault();
          e.stopPropagation();

          if (!canAddToCart()) {
            showFormError('Please choose all ' + slots.length + ' shades before adding to cart.');
            updateSubmitState();
            return;
          }

          addBundleToCart();
        },
        true
      );

      productForm.addEventListener('change', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('single-option-selector')) {
          setTimeout(function () {
            applyVariant(resolveCurrentVariant());
          }, 0);
        }
      });
    }

    if (productSection) {
      productSection.addEventListener('variantChange', function (event) {
        setTimeout(function () {
          var variant = (event.detail && event.detail.variant) || resolveCurrentVariant();
          applyVariant(variant);
        }, 0);
      });
    }

    applyVariant(resolveCurrentVariant());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
